var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElementVotes',{attrs:{"votes":_vm.votesAggregate,"current-user-vote-type":_vm.currentUserVoteType},on:{"voteClick":_vm.elementVoteClick}})}
var staticRenderFns = []

export { render, staticRenderFns }